/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/objectSpread";
import _objectWithoutProperties from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/objectWithoutProperties";
import _classCallCheck from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/classCallCheck";
import _createClass from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/createClass";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import { UBT } from '@hb/tianqi/lib/h5';
import store from '@/store'; // import config from '../const/config';

import env from '../utils/env';
UBT.config({
  env: env.codeEnv,
  debug: env.codeEnv !== 'pro',
  categoryId: 'switchpower'
});
var platform = 'H5';

if (env.isEasyBikeApp) {
  platform = env.platform.os;
} else if (env.isAlipayBrowser) {
  platform = 'Alipay';
} else if (env.isAliMPMonitor || env.isAliMP) {
  platform = 'Alipay_mini';
}

var defaultUbt = UBT.bindData({
  useragent: navigator.userAgent,
  appName: 'h5_HP',
  appversion: env.appVersion,
  platformAPP: env.platform.app,
  $platform: platform,
  $utm_source: 'H5',
  $appType: '哈啰换电',
  categoryId: '哈啰换电',
  codeEnv: process.env.NODE_ENV,
  userGuid: function userGuid() {
    return store.state.user.tianqiParams.userGuid;
  },
  cityCode: function cityCode() {
    return store.state.user.tianqiParams.cityCode;
  },
  adCode: function adCode() {
    return store.state.user.tianqiParams.adCode;
  },
  longitude: function longitude() {
    return store.state.user.tianqiParams.longitude;
  },
  latitude: function latitude() {
    return store.state.user.tianqiParams.latitude;
  }
});
var defaultBusinessInfo = {
  businessInfo: {
    platform: platform,
    cityCode: store.state.user.tianqiParams.cityCode
  }
};

var TQ =
/*#__PURE__*/
function () {
  function TQ() {
    _classCallCheck(this, TQ);
  }

  _createClass(TQ, null, [{
    key: "handle",
    value: function handle(method, options) {
      var businessInfo = options.businessInfo,
          params = _objectWithoutProperties(options, ["businessInfo"]);

      defaultUbt[method](_objectSpread({}, params, {
        businessInfo: _objectSpread({}, businessInfo, defaultBusinessInfo)
      }));
    }
  }, {
    key: "pageView",
    value: function pageView(options) {
      this.handle('pageView', options);
    }
  }, {
    key: "clickButton",
    value: function clickButton(options) {
      this.handle('clickButton', options);
    }
  }, {
    key: "pageViewOut",
    value: function pageViewOut(options) {
      this.handle('pageViewOut', options);
    }
  }]);

  return TQ;
}();

export default TQ;